<template>
    <div class="text-center mb-6">
      <h2 class="text-2xl md:text-3xl font-bold text-primary mb-3">
        Conheça o Mestre Rafael Arcano
      </h2>
      <p class="text-gray-600">
        Especialista em Numerologia e Autoconhecimento
      </p>
    </div>
  </template>